import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface FormGuardModalProps {
    isOpen: boolean;
    onStayOnPage: () => void;
    onLeaveWithoutSaving: () => void;
    onSaveAndContinue: () => void;
    isProcessing: boolean;
    hasSaveAction: boolean;
}

const FormGuardModal: React.FC<FormGuardModalProps> = ({
    isOpen,
    onStayOnPage,
    onLeaveWithoutSaving,
    onSaveAndContinue,
    isProcessing,
    hasSaveAction
}) => {
    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && onStayOnPage()}>
            <DialogContent className="sm:max-w-md" onPointerDownOutside={(e) => e.preventDefault()}>
                <DialogHeader className="border-0 pb-0">
                    <div className="flex items-center gap-2">
                        <span className="text-2xl">⚠️</span>
                        <span>Alterações não salvas</span>
                    </div>
                </DialogHeader>

                <div className="pt-0">
                    <p className="mb-3 text-muted-foreground">
                        Você fez alterações no formulário que ainda não foram salvas.
                        O que deseja fazer?
                    </p>
                    <div className="flex items-start gap-2 p-3 text-sm rounded-md bg-yellow-50 text-yellow-800 border border-yellow-200">
                        <span>💡</span>
                        <small>
                            <strong>Dica:</strong> Use <kbd className="px-1 py-0.5 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-300 rounded">Ctrl+S</kbd> para salvar rapidamente suas alterações.
                        </small>
                    </div>
                </div>

                <DialogFooter className="border-0 pt-0">
                    <div className="flex gap-2 w-full justify-end">
                        <Button
                            variant="outline"
                            onClick={onStayOnPage}
                            disabled={isProcessing}
                            size="sm"
                        >
                            Continuar editando
                        </Button>

                        <Button
                            variant="destructive"
                            onClick={onLeaveWithoutSaving}
                            disabled={isProcessing}
                            size="sm"
                        >
                            Sair sem salvar
                        </Button>

                        {hasSaveAction && (
                            <Button
                                onClick={onSaveAndContinue}
                                disabled={isProcessing}
                                size="sm"
                                className="flex items-center"
                            >
                                {isProcessing && (
                                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                )}
                                Salvar e continuar
                            </Button>
                        )}
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default FormGuardModal;
